import { SmIcon } from '@smiles/smiles-react-design-system';
import React, { useEffect, useRef, useState } from 'react';

import { useContextSelector } from '../../hooks';
import type { RentalType } from '../../types';

export interface ITimeInputProps {
  id: string;
  placeholder: string;
  placeholderIcon?: string;
  type: RentalType;
  disabled?: boolean;
  onTimeModalToggle: () => void;
}

export const TimeInput = ({
  id,
  disabled = false,
  placeholder,
  placeholderIcon,
  type,
  onTimeModalToggle,
  ...props
}: ITimeInputProps) => {
  const {
    generics: { isMobile },
    search: { time },
    inputs,
  } = useContextSelector();
  const [inputTextValue, setInputTextValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const input = inputRef.current as HTMLInputElement;

    if (isMobile && inputs.timeModal && type === 'pickup') {
      input.focus();
      input.click();
    }
  }, [isMobile, inputs, type]);

  // Persist input text according to context state
  useEffect(() => {
    if (time[type]) {
      setInputTextValue(time[type] as string);
    } else {
      setInputTextValue('');
    }
  }, [time[type]]);

  const handleInputFocus = () => {
    const input = inputRef.current as HTMLInputElement;

    input.focus();
    input.classList.add('focused');
    onTimeModalToggle();
  };

  const handleInputBlur = () => {
    const input = inputRef.current as HTMLInputElement;
    input.classList.remove('focused');
  };

  return (
    <section className="time-input-container" {...props}>
      <section className="time-input-field-wrapper">
        <input
          className="time-input-field"
          type="text"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          ref={inputRef}
          id={`time-input-field-${id}`}
          placeholder={placeholder}
          value={inputTextValue}
          disabled={disabled}
          onFocus={handleInputFocus}
          onClick={handleInputFocus}
          onBlur={handleInputBlur}
          readOnly
        />

        {placeholderIcon && (
          <SmIcon className="time-input-field-placeholder-icon" name={placeholderIcon} type="round" />
        )}
      </section>
    </section>
  );
};
